import { EVENT_TYPE } from '../../constants/eventTypes.js';
import { INTERIM_EVENT_TYPE } from '../../constants/interimEventTypes.js';
import GenericDecision from './GenericDecision.jsx';
import { ContinuationDecision } from '../EventTypes/Continuation/index.js';
import { HandoffDecision } from '../EventTypes/Handoff/index.js';
import { QuestionDecision } from '../EventTypes/Question/index.js';
import { TrainMeDecision } from '../EventTypes/TrainMe/index.js';
import { GovPromotionDecision } from '../EventTypes/GovPromotion/index.js';
import { GovReviewDecision } from '../EventTypes/GovReview/index.js';
import { BreakGlassDecision } from '../EventTypes/BreakGlass/index.js';
import { TaskDecision } from '../EventTypes/Task/index.js';
import { ChangeRequestDecision } from '../EventTypes/ChangeRequest/index.js';
import { ClaimSuggestionDecision } from '../EventTypes/ClaimSuggestion/index.js';
import { ProposalDecision } from '../EventTypes/Proposal/index.js';

/**
 * Maps an event type to its decision component (sticky footer buttons + confirm
 * modals). Per-event-type stories (CT-4859..CT-4865) register their decisions
 * here. Unregistered types fall back to the generic single-primary decision.
 *
 * The DECISION bar is sticky OUTSIDE the body's scroll container in the inbox
 * split, so per-type decisions are resolved here (not inline in the flush body).
 */
export const EVENT_DECISION_REGISTRY = {
  [EVENT_TYPE.HTL_CONTINUATION]: ContinuationDecision,
  [EVENT_TYPE.CLIENT_CONTINUATION]: ContinuationDecision,
  [EVENT_TYPE.HTL_HANDOFF]: HandoffDecision,
  [EVENT_TYPE.CLIENT_HANDOFF]: HandoffDecision,
  [EVENT_TYPE.QUESTION]: QuestionDecision,
  [EVENT_TYPE.TRAIN_ME]: TrainMeDecision,
  [EVENT_TYPE.GOV_PROMOTION]: GovPromotionDecision,
  [EVENT_TYPE.GOV_REVIEW]: GovReviewDecision,
  [EVENT_TYPE.GOV_BREAK_GLASS]: BreakGlassDecision,
  // Interim cross-plane task (CT-5093): Resolve persists to the task service.
  [INTERIM_EVENT_TYPE.TASK]: TaskDecision,
  // Interim governance decisions (CT-5095): change-request/resolve + claim-suggestion.
  [INTERIM_EVENT_TYPE.CHANGE_REQUEST]: ChangeRequestDecision,
  [INTERIM_EVENT_TYPE.CLAIM_SUGGESTION]: ClaimSuggestionDecision,
  [INTERIM_EVENT_TYPE.PROPOSAL]: ProposalDecision,
};

export function resolveEventDecision(type) {
  return EVENT_DECISION_REGISTRY[type] ?? GenericDecision;
}
